import { useAuth } from '../AuthContext';
import { Navigate } from 'react-router-dom';

export function AuthMiddlewareAdmin({ children }) {
  const { isAuthenticated, userLogado } = useAuth();

  // Verifica se o usuário está autenticado
  if (!isAuthenticated  ) {
    // Se não estiver autenticado, redireciona para a página de login
    return <Navigate to="/login" />;
  }

  if (isAuthenticated && userLogado.perfil!=='Admin' && userLogado.perfil!=='Diretor') {
    // Se não estiver autenticado, redireciona para a página de login
    return <Navigate to="/" />;
  }

  // Se estiver autenticado, permite o acesso à rota
  return children;
}
